module.exports = __webpack_public_path__ + "static/media/C.26603f18.png";